import styled from "styled-components"

import {RouterLink} from "@irati/ui/src/Link"
import {regularStyles} from "@irati/ui/src/Typography/Label/styles"
import {WorkSansBold} from "@irati/ui/src/global/fonts"

export default styled(RouterLink).attrs({
  styled: false
})`
  display: block;
  padding: 10px 15px;
  margin: 0 10px;
  text-decoration: none;
  cursor: pointer;
  background-color: ${({isCurrent, theme}) => {
    const {lightest, white} = theme.colors.greys
    return isCurrent ? lightest : white
  }};
  color: ${({color, theme}) => color || theme.colors.greys.black};

  &:hover,
  &:focus,
  &:active {
    color: ${({color, theme}) => color || theme.colors.greys.black};
    background-color: ${({theme}) => theme.colors.greys.graphGrey};
    text-decoration: none;
  }
  ${regularStyles}
  ${WorkSansBold}
`
